import { ReactNode } from 'react'
import LinkButtonStyles from './LinkButton.css'


interface LinkButtonProps {
  id?: string
  children?: ReactNode
  href?: string
}

const LinkButton: React.FC<LinkButtonProps> = ({ id, children, href = "#" }) => {
  return (
    <>
      <style>{LinkButtonStyles}</style>
      <a id={id} className="link-button" href={href} onClick={(e) => e.preventDefault()}>{children}</a>
    </>
  )
}

export default LinkButton
export type { LinkButtonProps }
